import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoneAll = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "done_all_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/action/done_all_24px",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.205 5.29501L11.625 15.875L7.445 11.705L6.035 13.115L11.625 18.705L23.625 6.70501L22.205 5.29501ZM17.965 6.70501L16.555 5.29501L10.215 11.635L11.625 13.045L17.965 6.70501ZM5.965 18.705L0.375 13.115L1.795 11.705L7.375 17.295L5.965 18.705Z",
			fill: "#fad504"
		})
	})]
});
const ForwardRef = forwardRef(SvgDoneAll);
export default ForwardRef;
